export default __webpack_public_path__ + "static/media/tik-2.ab853523.svg";